import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { BeatLoader } from 'react-spinners';

const CameraStatusChart = ({ data, setIsSwitchOnCameraExpired, setIsSwitchOnCameraCritical, setIsSwitchOnCameraHealthy, averageOperatingDaysCameras, loading }) => {

     const renderLoader = () => (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'auto' }}>
          <BeatLoader size={8} color="#ccc"/>
        </div>
      );

    const healthy = data.datasets[0].data[0];
    const critical = data.datasets[0].data[1];
    const expired = data.datasets[0].data[2];
    const total = loading ? '⌛' : healthy + critical + expired;
    
    const handleClick = (event, elements) => {
        if (elements.length > 0) {
            const { index } = elements[0];
            const label = data.labels[index];
            const value = data.datasets[0].data[index];
            console.log(`Label: ${label}, Value: ${value}`);

            if (label === 'Critical') {
              setIsSwitchOnCameraExpired(false);
              setIsSwitchOnCameraHealthy(false);
              setIsSwitchOnCameraCritical(prev => !prev);
            } else if (label === 'Expired') {
                setIsSwitchOnCameraCritical(false);
                setIsSwitchOnCameraHealthy(false);
                setIsSwitchOnCameraExpired(prev => !prev);
            } else if (label === 'Healthy') {
                setIsSwitchOnCameraExpired(false);
                setIsSwitchOnCameraCritical(false);
                setIsSwitchOnCameraHealthy(prev => !prev);
            }
        }
  };

    return (
  <div className='lifecycle-chart-container'>    
    <div className='lifecycle-legend'>
      <div className='lifecycle-legend-item'>
        { loading ? (
            renderLoader()
        ) : (
            <div className='lifecycle-legend-item-value-total'>{total}</div>
        )}
          <div className='lifecycle-legend-item-label'>Healthy</div>                    
      </div>
      <div className='lifecycle-legend-item'>
          { loading ? (
              renderLoader()
          ) : (
              <div className='lifecycle-legend-item-value-critical'>{critical}</div>
          )}
          <div className='lifecycle-legend-item-label'>Critical</div>                    
      </div>
      <div className='lifecycle-legend-item'>
        { loading ? (
            renderLoader()
        ) : (
            <div className='lifecycle-legend-item-value-expired'>{expired}</div>
        )}
          <div className='lifecycle-legend-item-label'>Expired</div>                    
      </div>
    </div>
    <div className='center-align-chart'>
      <Doughnut
        data={data}
        options={{
          responsive: true,
          cutout: '71%',
          maintainAspectRatio: false,
          plugins: {
              legend: {
                display: false, // Hides the legend
              },
              tooltips: {
                callbacks: {
                  label: function(tooltipItem, data) {
                    let label = data.labels[tooltipItem.index];
                    let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                    return `${label}: ${value}`;
                  },
                },            
              },
            centerText: {
              display: true,
              title: total,                // Top number
              subtitle: 'Total Cameras',  // Bottom label
              color: '#ffffff',
              fontSize: 24,
              fontStyle: 'bold',
              subtitleFontSize: 14,
              subtitleFontStyle: 'normal'
            },
          },
            onClick: (event, elements) => handleClick(event, elements),
        }}

        plugins={[
          {
                    id: 'centerText',
                    beforeDraw: function (chart) {
                    const { width, height, ctx } = chart;
                    const pluginConfig = chart.options.plugins.centerText;

                    if (!pluginConfig?.display) return;

                    ctx.save();

                    // Calculate center
                    const centerX = width / 2;
                    const centerY = height / 2;

                    // Draw top line (title)
                    ctx.font = `${pluginConfig.fontStyle || 'bold'} ${pluginConfig.fontSize || 24}px sans-serif`;
                    ctx.fillStyle = pluginConfig.color || '#333';
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(pluginConfig.title, centerX, centerY - 10);

                    // Draw bottom line (subtitle)
                    ctx.font = `${pluginConfig.subtitleFontStyle || 'normal'} ${pluginConfig.subtitleFontSize || 14}px sans-serif`;
                    ctx.fillText(pluginConfig.subtitle, centerX, centerY + 14);

                    ctx.restore();
                    }
                }
              ]}
      />
    </div>    
  </div>
)};

export default CameraStatusChart;
